import { Route } from '@angular/router';
import { FinanceExtractsComponent } from './extracts/finance-extracts.component';
import { FinanceComponent } from './finance.component';
import { FinanceListingComponent } from './listing/finance-listing.component';
import { FinanceManageComponent } from './manage/finance-manage.component';
import { AuthGuardMonthEnd } from '@intranet/core/services/auth-guard.service';

export const financeRoutes: Route[] = [
    {
        path: 'finance',
        component: FinanceComponent,
        children: [
            { path: '', redirectTo: '/finance/estimates', pathMatch: 'full' },
            {
                path: ':financeType/create',
                component: FinanceManageComponent,
            },
            {
                path: ':financeType/:id',
                component: FinanceManageComponent,
            },
            {
                path: ':financeType/:id/copy',
                component: FinanceManageComponent,
                data: { copy: true },
            },
            {
                path: 'invoices/:id/to-invoice',
                component: FinanceManageComponent,
                data: { copy: true, copyToInvoice: true },
            },
            {
                path: 'invoices/:id/to-credit',
                component: FinanceManageComponent,
                data: { copy: true, copyToCredit: true },
            },
            {
                path: 'estimates',
                component: FinanceListingComponent,
                data: { financeType: 1 },
            },
            {
                path: 'invoices',
                component: FinanceListingComponent,
                data: { financeType: 2 },
            },
            // Add a new route for 'creditnotes' which redirects to 'invoices' with financeType 2
            {
                path: 'creditnotes',
                redirectTo: 'invoices',
                pathMatch: 'full',
                data: { financeType: 2 },
            },
            {
                path: 'monthend',
                component: FinanceListingComponent,
                canActivate: [AuthGuardMonthEnd],
                data: { financeType: 2, monthEnd: true },
            },
            {
                path: 'extracts',
                component: FinanceExtractsComponent,
            },
        ],
    },
];
